// src/customFetch.js (refactorizado sin refresh tokens)
import AuthService from './services/AuthService';

/**
 * Versión mejorada de customFetch con manejo de tokens de sesión más seguro
 * @param {string} url - URL a la que hacer la petición
 * @param {Object} options - Opciones para fetch (method, headers, etc.)
 * @returns {Promise<Response>} - Respuesta de la petición
 */
export async function customFetch(url, options = {}) {
  try {
    // Aseguramos que tenemos headers
    if (!options.headers) {
      options.headers = {};
    }

    // Verificar si hay una sesión activa
    if (AuthService.isAuthenticated() && !options.headers['Authorization']) {
      // Verificar si el token ha expirado
      if (AuthService.isSessionExpired()) {
        // Si ha expirado, cerrar sesión y redirigir
        console.error('Sesión expirada - cerrando sesión');
        AuthService.logout();
        alert('Su sesión ha expirado. Por favor, inicie sesión nuevamente.');
        window.location.href = '/login';
        throw new Error('Sesión expirada');
      }
      
      // Agregar el token de acceso al header
      const token = AuthService.getAccessToken();
      options.headers['Authorization'] = `Bearer ${token}`;
    }

    // Realizamos la petición
    const response = await fetch(url, options);
    
    // Verificamos si hay un error de autenticación
    if (response.status === 401) {
      console.warn('Error de autenticación detectado');
      
      // Solo limpiamos la sesión si realmente es un error de autorización
      // y no otro tipo de error con código 401
      if (response.statusText === 'Unauthorized') {
        console.error('Sesión no autorizada - cerrando sesión');
        AuthService.logout();
        alert('Su sesión ha expirado. Por favor, inicie sesión nuevamente.');
        window.location.href = '/login';
        throw new Error('Sesión expirada');
      }
    }
    
    // Si no es un error de autenticación, revisamos si hay otros errores
    if (!response.ok) {
      // Intentamos obtener el mensaje de error del servidor
      try {
        const errorData = await response.json();
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      } catch (jsonError) {
        // Si no podemos analizar la respuesta como JSON, usamos el statusText
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
    }
    
    return response;
  } catch (error) {
    console.error('customFetch error:', error);
    
    // Solo propagamos el error, sin cerrar sesión automáticamente
    // a menos que ya hayamos detectado un error 401 arriba
    throw error;
  }
}